import React from "react";
import { Box } from "@mui/material";
import classess from "./Home.module.css";
import linux from "../assets/file2.jpg";
import T from "../assets/0.jpg";

const Home = (props) => {
  return (
    <Box className={classess.Home}>
      <img className={classess.Linux} src={linux} alt="" />
      <img className={classess.T} src={T} alt="" />
    </Box>
  );
};

export default Home;
